import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AgGridComponent } from './ag-grid/ag-grid.component';
import { AgGridModule } from '@ag-grid-community/angular';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ModuleRegistry } from '@ag-grid-community/core';
import { StatusBarModule } from '@ag-grid-enterprise/status-bar';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { PaginationBarComponent } from './pagination-bar/pagination-bar.component';
import { GridService } from './service/grid.service';
import { ModuleHeaderComponent } from './modul-header/module-header.component';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SwalService } from './service/swal.service';
import { CacheBusterDirective } from './directives/cache-buster.directive';
import { UsNumericFormatPipe } from './pipes/us-numeric-format.pipe';
import { SharedSvgComponent } from './shared-svg/shared-svg.component';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { JoyrideModule } from 'ngx-joyride';
import { SectionFilterPipe } from './pipes/section-filter.pipe';
import { DecimalLimitDirective } from './directives/decimal-limit.directive';
import { DraggableDirective } from './directives/draggable.directive';
import { CopyOrganizationService } from './service/copy-organization.service';
import { TocListComponent } from './toc-list/toc-list.component';
import { PreventDotInputDirective } from './directives/preventdotinput.directive';
import { CommonService } from './service/common.service';
import { InstructionsComponent } from './instructions/instructions.component';
import { ManageUserService } from './service/manage-user.service';
import { CkeditorComponent } from './ckeditor/ckeditor.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { AccessPermissionDirective } from './directives/access-permission.directive';
import { InputNumberValidationDirective } from './directives/input-number-validation.directive';

import { VersionDetectService } from './service/AppUpdateServices/version-detect.service';
import { AppUpdateService } from './service/AppUpdateServices/app-update.service';
import { SectionAccessDirective } from './directives/section-access.directive';
import { FeatureLockComponent } from './components/feature-lock/feature-lock.component';
import { FeatureConfigService } from './service/feature-config.service';
import { CrownIconComponent } from './components/crown-icon/crown-icon.component';
import { TimezoneConverterPipe } from './pipes/timezone-converter.pipe';
import { InputNumberDirective } from './directives/input-number.directive';
import { CommonInputComponent } from './components/common-input/common-input.component';
import { DecimalFormatPipePipe } from './pipes/decimal-format-pipe.pipe';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { CommonTableComponent } from './components/common-table/common-table.component';
import { InlineLoaderComponent } from './components/loader-message/inline-loader.component';

// Register the required feature modules with the Grid
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  StatusBarModule,
  ColumnsToolPanelModule,
  ServerSideRowModelModule,
  RowGroupingModule,
  //MenuModule
]);

@NgModule({
  imports: [
    ReactiveFormsModule,
    CKEditorModule,
    CommonModule,
    NgbModule,
    AgGridModule,
    ModalModule.forRoot(),
    FormsModule,
    NgSelectModule,
    JoyrideModule.forChild(),
  ],
  exports: [
    NgbModule,
    AgGridComponent,
    ModuleHeaderComponent,
    CacheBusterDirective,
    UsNumericFormatPipe,
    SharedSvgComponent,
    SectionFilterPipe,
    DecimalLimitDirective,
    DraggableDirective,
    TocListComponent,
    PreventDotInputDirective,
    CkeditorComponent,
    AccessPermissionDirective,
    SectionAccessDirective,
    FeatureLockComponent,
    CrownIconComponent,
    TimezoneConverterPipe,
    InputNumberDirective,
    CommonInputComponent,
    DecimalFormatPipePipe,
    FileUploadComponent,
    CommonTableComponent,
    InlineLoaderComponent,
  ],
  declarations: [
    AgGridComponent,
    PaginationBarComponent,
    ModuleHeaderComponent,
    SidebarComponent,
    CacheBusterDirective,
    UsNumericFormatPipe,
    SharedSvgComponent,
    SectionFilterPipe,
    DecimalLimitDirective,
    DraggableDirective,
    TocListComponent,
    PreventDotInputDirective,
    InstructionsComponent,
    CkeditorComponent,
    AccessPermissionDirective,
    InputNumberValidationDirective,
    TimezoneConverterPipe,
    SectionAccessDirective,
    FeatureLockComponent,
    CrownIconComponent,
    InputNumberDirective,
    CommonInputComponent,
    DecimalFormatPipePipe,
    FileUploadComponent,
    CommonTableComponent,
    InlineLoaderComponent,
  ],
  providers: [
    GridService,
    SwalService,
    CopyOrganizationService,
    CommonService,
    ManageUserService,
    VersionDetectService,
    AppUpdateService,
    FeatureConfigService,
  ],
})
export class SharedModule {}
